module.exports = __webpack_public_path__ + "static/media/autosign-off.39763099.svg";